import { MEMBERS_ONLY_PROMO_CODE, DUMMY_PROMO_CODE } from './constants'

export const isPromoCode = (code: string | null | undefined): boolean => {
  if (!code) return false

  return code.startsWith(MEMBERS_ONLY_PROMO_CODE) || code === DUMMY_PROMO_CODE
}
